<div class="bmc-sync-data__container">

  <div class="bmc-sync-data">
    <h5 class="bmc-sync-data__title bz-font-weight--semibold">{{'SYNC_DATA.IMPORT_EXPORT_DATA' | translate}}</h5>
  </div>
  <p>
    {{'SYNC_DATA.DESCRIPTION' | translate}}
  </p>
  <div>
  <bzg-button-primary class="bmc-sync-data__button" (click)="importFile()">
    {{'SYNC_DATA.IMPORT_FILE' | translate}}
  </bzg-button-primary>
  <bzg-button-secondary class="bmc-sync-data__button" (click)="exportFile()">
    {{'SYNC_DATA.EXPORT_FILE' | translate}}
  </bzg-button-secondary>
  </div>

</div>

<div class="bmc-sync-data__container-data">
  <ng-template #exportTemplate>
    <biz-sync-data-export (onFinish)="closeModal()"></biz-sync-data-export>
  </ng-template>

  <ng-template #importTemplate>
    <biz-sync-data-import (onFinish)="closeModal()"></biz-sync-data-import>
  </ng-template>

  <biz-import-history-table [history]="historyImported"></biz-import-history-table>
  <biz-export-history-table [history]="historyExported"></biz-export-history-table>
</div>
